import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { skills } from '../data/skills';
export function Skills() {
  return <section id="skills" className="bg-white py-24 lg:py-32" data-id="element-162" data-mp="13h6uzk9mph43">
      <div className="max-w-content mx-auto px-6 lg:px-10" data-id="element-163" data-mp="13irpxazuv22h">
        <SectionHeading eyebrow="03 — Skills" title="Core Functional Expertise" data-id="element-164" data-mp="ypyp2y7icdvo" />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200" data-id="element-165" data-mp="1df4i24fr57v4">
          {skills.map((skill, index) => {
          const Icon = skill.icon;
          return <motion.div key={skill.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            ease: [0.23, 1, 0.32, 1],
            delay: index % 3 * 0.06
          }} className="group bg-white p-8 hover:bg-slate-50 transition-colors duration-200" data-id="element-166" data-mp="1mgkqw7qx51x8" data-mpi={index}>
                <div className="flex h-11 w-11 items-center justify-center border border-slate-300 text-slate-700 group-hover:border-gold group-hover:text-gold-dark transition-colors duration-200" data-id="element-167" data-mp="gkouffylj035">
                  <Icon className="h-5 w-5" strokeWidth={1.5} data-id="element-168" data-mp="qfqj6aoym057" />
                </div>
                <h3 className="mt-5 font-serif text-lg font-semibold text-navy" data-id="element-169" data-mp="v933w9qipmso">{skill.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600" data-id="element-170" data-mp="z8lh0jc3ktky">{skill.description}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}